import {
    fetchAuthSession,
    fetchUserAttributes,
    getCurrentUser
} from 'aws-amplify/auth';
import type { AppDispatch } from '../../app/store';
import {
    fetchUserDataFailure,
    fetchUserDataInit,
    fetchUserDataSuccess,
    resetUserData
} from '../../app/authSlice';
import { userApi } from '../../api/userApi';
import { LoginType } from '../../api-types/models/LoginDto';
import { toSerializableAuthUser } from '../user';
import type { CognitoUser } from '../../interfaces/cognitoUser';

export async function hydrateCognitoAuthUser(
    dispatch: AppDispatch
): Promise<boolean> {
    dispatch(fetchUserDataInit());

    try {
        const session = await fetchAuthSession({ forceRefresh: true });
        const user = await getCurrentUser();
        const attributes = await fetchUserAttributes();

        const cognitoUser: CognitoUser = {
            username: user.username,
            userId: user.userId,
            signInDetails: user.signInDetails,
            challengeName: '',
            attributes: {
                email: attributes.email ?? user.username
            },
            signInUserSession: {
                accessToken: {
                    payload: session.tokens?.accessToken?.payload ?? {}
                }
            }
        };

        dispatch(fetchUserDataSuccess(toSerializableAuthUser(cognitoUser)));

        const userGroups = session.tokens?.accessToken?.payload[
            'cognito:groups'
        ] as string[] | undefined;

        if (
            userGroups &&
            !userGroups.includes(LoginType.BRUNCH) &&
            !userGroups.includes(LoginType.COACH)
        ) {
            dispatch(
                userApi.util.prefetch('getUserSettings', undefined, {
                    force: true
                })
            );
        }

        return true;
    } catch (error) {
        console.error('Failed to hydrate Cognito auth user', error);
        dispatch(resetUserData());
        dispatch(fetchUserDataFailure());
        return false;
    }
}
